<template>
    <b-container class="m-3">
        <b-row>
            <b-col>
                <p class="h4">
                    <strong>People Also Viewed</strong>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <div class="d-flex flex-row">
                <PeopleAlsoViewed/>
                <PeopleAlsoViewed/>
                <PeopleAlsoViewed/>
            </div>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
import PeopleAlsoViewed from './PeopleAlsoViewed'

export default {
    components: {
        PeopleAlsoViewed
    },
    data() {
        return {
            
        }
    }
    
}
</script>